module.exports = __webpack_public_path__ + "img/enterpriseWechat.50c7f9be.png";